const textProps = {
  headingBadge: {
    whiteContent: true,
    title: "Innovation at your fingertips",
    description: "Drop a message to our team to see how we can help you",
    alignment: "center",
  },
};
export default textProps;
